function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M39.909,26h3.084C42.995,26.109,43,26.217,43,26.327C43,38.849,34.941,49,25,49S7,38.849,7,26.327c0-0.11,0.005-0.218,0.007-0.327 h3.266"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25,1c-2.481,0-4.5,2.019-4.5,4.5S22.519,10,25,10s4.5-2.019,4.5-4.5S27.481,1,25,1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.101,23.649l-8.34-9.731C31.716,12.699,30.194,12,28.588,12h-7.176c-1.608,0-3.131,0.7-4.177,1.922l-8.332,9.724 c-0.688,0.803-0.624,2,0.144,2.726c0.735,0.696,1.977,0.698,2.716,0.004l7.571-7.116l0.627,24.71C19.989,45.107,20.905,46,22.045,46 c1.074,0,1.986-0.838,2.076-1.908L25.082,32.8l0.753,6.335c0.126,1.063,1.029,1.865,2.1,1.865c1.149,0,2.078-0.9,2.114-2.049 l0.611-19.697l7.607,7.15c0.36,0.339,0.831,0.525,1.325,0.525c0.497,0,0.969-0.188,1.355-0.554 C41.719,25.646,41.786,24.449,41.101,23.649z"
});

function SvgJumprope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumprope);
export default __webpack_public_path__ + "static/media/jumprope.de1a30e1.svg";
export { ForwardRef as ReactComponent };